import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="homepage">
      <div className="homepage-container">
        <div className="hero-section">
          <h1>🏪 A2Z Tak Store</h1>
          <p>Complete Inventory Management System</p>
          <p className="subtitle">With EMI Facilities & Customer Portal</p>
        </div>

        <div className="portal-cards">
          <div className="portal-card admin-card">
            <div className="card-icon">👨‍💼</div>
            <h2>Admin Dashboard</h2>
            <p>Manage your inventory, customers, EMI, and sales</p>
            <ul>
              <li>✅ Product Management</li>
              <li>✅ Customer Management</li>
              <li>✅ EMI Tracking</li>
              <li>✅ Sales Analytics</li>
              <li>✅ Business Intelligence</li>
            </ul>
            <Link to="/admin" className="portal-btn admin-btn">
              Go to Admin Dashboard
            </Link>
          </div>

          <div className="portal-card customer-card">
            <div className="card-icon">🛍️</div>
            <h2>Customer Portal</h2>
            <p>Browse products and calculate EMI options</p>
            <ul>
              <li>✅ Browse Available Products</li>
              <li>✅ EMI Calculator</li>
              <li>✅ 40% Down Payment</li>
              <li>✅ 6 Months No-Cost EMI</li>
              <li>✅ Product Search & Filter</li>
            </ul>
            <Link to="/customer-portal" className="portal-btn customer-btn">
              Go to Customer Portal
            </Link>
          </div>
        </div>

        <div className="features-section">
          <h2>Key Features</h2>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">📱</div>
              <h3>EMI Management</h3>
              <p>Complete EMI tracking with 6-month no-cost options</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">📊</div>
              <h3>Analytics</h3>
              <p>Business intelligence and growth analytics</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🤖</div>
              <h3>AI Chatbot</h3>
              <p>Customer support with AI-powered chatbot</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">💳</div>
              <h3>Payment Options</h3>
              <p>Cash, Credit Card, UPI, and Self Finance</p>
            </div>
          </div>
        </div>

        <div className="contact-section">
          <h2>Contact Information</h2>
          <div className="contact-info">
            <p>📍 Location: Punjab, India</p>
            <p>🌐 Website: A2ztak.in</p>
            <p>📞 For EMI applications and inquiries</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
